export default __webpack_public_path__ + "static/media/Rakibul-Islam.11035086.jpg";